// Carousel setup for Categories (CatSwiper)
class CatSwiper {
  constructor(container) {
    this.container = container;
    this.sliderControls = container.querySelector('.beast_cat_navigation');
    this.sliderInstance = null;
    this.initSlider();
  }

  initSlider() {
    const options = {
      slidesPerView: 5.2,
      spaceBetween: 20,
      autoHeight: true,
      grabCursor: false,
      allowTouchMove: false,
      loop: false,
      navigation: {
        nextEl: ".beast_cat_next",
        prevEl: ".beast_cat_prev",
      },
      breakpoints: {
        200: { slidesPerView: 1.2, allowTouchMove: true },
        520: { slidesPerView: 2.2, allowTouchMove: true },
        768: { slidesPerView: 3.2, allowTouchMove: true },
        1024: { slidesPerView: 5.2 }
      }
    };

    this.sliderInstance = new window.FoxTheme.Carousel(this.container, options);
    this.sliderInstance.init();
  }
}

// Initialize carousel if the element exists
document.addEventListener('DOMContentLoaded', () => {
  const catSwiperEl = document.querySelector('.cat_swiper');
  if (catSwiperEl) {
    new CatSwiper(catSwiperEl);
  }
});